import React, {useState, useEffect, useRef} from 'react';

import {Redirect, Route, RouteComponentProps, Switch, useParams} from 'react-router-dom';

import {history} from '../../helpers/history';

import SigninForm from './signIn/SigninForm'

import RegisterForm from './register/RegisterForm';
import {CompleteRegistration} from './completeRegistration/CompleteRegistration';

import {IEmailSentRef} from './emailSent/EmailSent';

import ForgotPasswordForm, {IForgotPasswordFormRef} from './forgotPassword/ForgotPasswordForm';

import ResetPassword from './resetPassword/ResetPassword';

import logo from '../../assets/logo.svg';

import './AuthScreen.scss';
import {makeStyles} from "@mui/styles";
import {Box, useMediaQuery} from "@mui/material";
import {IAuthParamsDto, UserDto} from "../../dtos";
import AuthPrivacy from "../../com/authPrivacy/AuthPrivacy";
import { CompleteUserRegistration } from './completeUserRegistration/CompleteUserRegistration';
import SetPassword from "./setPassword/SetPassword";

const useStyles = makeStyles(() => ({
    authScreen: {
        height: document.documentElement.offsetHeight,
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
        flexFlow: `column`,
        // padding: `15px`
    },
    logo: (props: any) => ({
        width: props.isXs ? `40%` : `158px`,
        cursor: `pointer`
        // [theme.breakpoints.down('xs')]: {
        //     width: `30%`
        // }
    }),
    authContentWrapper: (props: any) => ({
        width: "100%",
        flex: "1 1 auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    })
}))

interface RouteParams {
    userId?: string;
    token?: string;
}

interface IAuthScreen extends RouteComponentProps<RouteParams> {

}

const AuthScreen: React.FC<IAuthScreen> = (props) => {
    const {userId, userEmail, token, screenName} = useParams<IAuthParamsDto>();
    const projectName = "flyersCatalog";


    let forgotPasswordFormRef = useRef<IForgotPasswordFormRef>(null);
    let sendEmailRef = useRef<IEmailSentRef>(null);

    /*
        const showForm = (type: FormsTypes, initiatorType: FormsTypes) => {
            setCurrentInitiatorForm(initiatorType)
            setCurrentForm(type)
        }
    */
    const isXs = useMediaQuery(`(max-width:419px)`);
    const isSm = useMediaQuery(`(max-width:899px)`);
    const stylesProperties = {
        isXs: isXs,
        isSm: isSm
    }
    const classes = useStyles(stylesProperties);

    enum FormsTypes {
        Register,
        EmailSent,
        CompleteRegistration,

        Signin,
        ForgotPassword,

        ResetPassword
    }

    const isUrlInResetPasswordMode = () => {
        let res = props.location.pathname.includes('resetPassword');
        return res;
    }

    const isUrlInCompleteRegistrationMode = () => {
        let res = props.location.pathname.includes('completeRegistration');
        return res;
    }

    //
    let isResetPasswordMode = isUrlInResetPasswordMode();
    let isCompleteRegistrationMode = isUrlInCompleteRegistrationMode();

    let splitted = props.location.pathname.split("/");
    // let userId = 0
    // let userEmail = ''
    // let token = ''

    //
    let initialForm: FormsTypes = FormsTypes.Signin;
    // let initialCompleteRegistrationUrl = ''


    if (isCompleteRegistrationMode) {
        // userId = parseInt(splitted[3]);
        // userEmail = splitted[4];
        // token = splitted[5];

        initialForm = FormsTypes.CompleteRegistration;
    } else if (isResetPasswordMode) {
        // userId = parseInt(splitted[3]);
        // userEmail = splitted[4];
        // token = splitted[5];

        initialForm = FormsTypes.ResetPassword;
    }

    // the + sign convert the reference to int
    const [currentForm, setCurrentForm] = useState(+initialForm)
    // const [currentInitiatorForm, setCurrentInitiatorForm] = useState(+initialForm)

    //
    const handleResendAnotherEmail = () => {
        // the + sign convert the reference to int
        forgotPasswordFormRef.current?.sendEmail();
        sendEmailRef.current?.showLoader(true)

        /*
                let currentFormType = +currentForm

                if (currentInitiatorForm === FormsTypes.Register) {

                } else if (currentInitiatorForm === FormsTypes.ForgotPassword) {
                    forgotPasswordFormRef.current?.sendEmail();
                    sendEmailRef.current?.showLoader(true)
                }
        */
    }

    useEffect(() => {
        let userDtoStr = localStorage.getItem('userDto');
        let userDto: UserDto = JSON.parse(userDtoStr!);

        if (userDto !== null &&  screenName !== "completeUserRegistration") {
            history.push(`/flyersCatalog`);
            // if (projectName) {
            //     history.push(isMobile ? '/flipbookEditor' : userDto.accountTier === 10 ? `/flyersCatalog` : `/flipbookEditor`);
            // } else {
            //     history.push(isMobile ? '/flipbookEditor' : `/flyersCatalog`);
            // }
        }
    }, []);

    let redirectPath = `/auth/flyersCatalog/signInForm`;
    // let redirectPath = projectName ? `/auth/${projectName}/signInForm` : `/auth/flyersCatalog/signInForm`;

    return (
        <Box className={classes.authScreen}>
            <Box
                sx={{
                    height: `100%`,
                    display: "flex",
                    flexFlow: "column",
                    width: isXs ? `100%` : `375px`,
                    padding: "0 15px"
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "32px"
                    }}
                >
                    <img
                        alt={"No Image"}
                        src={logo}
                        className={classes.logo}
                        onClick={() => {
                            // showForm(FormsTypes.Signin, FormsTypes.Signin)
                            // history.push('/auth');
                            history.push(`/auth/${projectName}/signInForm`)
                        }}
                    />
                </Box>

                <Box className={classes.authContentWrapper}>
                    <Switch>
                        <Route exact path="/auth/flyersCatalog/registerForm" component={() => {
                            return <RegisterForm
                                refEmail={sendEmailRef}
                                onSigninClick={() => {
                                    history.push(`/auth/${projectName}/signInForm`)
                                }}
                                onRegisterSucceeded={() => {
                                    // history.push(`/auth/${projectName}/emailSent`)
                                }}
                            />
                        }}/>
                        <Route exact path="/auth/flyersCatalog/signInForm" component={() => {
                            return <SigninForm
                                onForgotPasswordClick={() => {
                                    history.push(`/auth/${projectName}/forgotPasswordForm`)
                                }}
                                onRegisterClick={() => {
                                    history.push(`/auth/${projectName}/registerForm`)
                                }}
                            />
                        }}/>
                        {/*<Route exact path="/auth/flyersCatalog/emailSent" component={() => {*/}
                        {/*    return <EmailSent*/}
                        {/*        ref={sendEmailRef}*/}
                        {/*        onResendAnotherEmailClick={handleResendAnotherEmail}*/}
                        {/*    />*/}

                        {/*}}/>*/}
                        <Route exact path="/auth/flyersCatalog/forgotPasswordForm" component={() => {
                            return <ForgotPasswordForm
                                ref={forgotPasswordFormRef}
                                refEmail={sendEmailRef}
                                show={currentForm == FormsTypes.ForgotPassword}
                                handleResendAnotherEmail={handleResendAnotherEmail}
                                onEmailSent={() => {
                                    sendEmailRef.current?.showLoader(false);
                                    // history.push(`/auth/${projectName}/emailSent`)
                                    // showForm(FormsTypes.EmailSent, FormsTypes.ForgotPassword)
                                }}/>

                        }}/>
                        {/*{*/}
                        {/*    userId && userEmail && token &&*/}
                        <Route exact path="/auth/flyersCatalog/resetPassword/:userId/:userEmail/:token"
                               component={() => {
                                   return <ResetPassword
                                       userId={Number(userId)}
                                       userEmail={userEmail!}
                                       userToken={token!}
                                       onSigninClick={() => {
                                           history.push(`/auth/${projectName}/signInForm`)
                                           // showForm(FormsTypes.Signin, FormsTypes.ResetPassword)
                                       }}
                                   />
                               }}/>
                        <Route exact path="/auth/flyersCatalog/setPassword/:userId/:userEmail/:token"
                               component={() => {
                                   return <SetPassword
                                       userId={Number(userId)}
                                       userEmail={userEmail!}
                                       userToken={token!}
                                       onSigninClick={() => {
                                           history.push(`/auth/${projectName}/signInForm`)
                                           // showForm(FormsTypes.Signin, FormsTypes.ResetPassword)
                                       }}
                                   />
                               }}/>
                        <Route exact path="/auth/flyersCatalog/completeRegistration/:userId/:userEmail/:token"
                               component={() => {
                                   return <CompleteRegistration
                                       userId={Number(userId)}
                                       userEmail={userEmail!}
                                       userToken={token!}
                                       onRegisterEmailSucceeded={() => {
                                           // let loginDto: LoginDto = {
                                           //     emailAddress: userDto.,

                                           //     password
                                           // }
                                           // dispatch(actionCreators.login(loginDto));
                                           let userDto = localStorage.getItem('userDto');
                                           if (userDto) {
                                               // const userDtoParse: UserDto = JSON.parse(userDto);
                                               history.push('/flyersCatalog');
                                               /*
                                                                                              if (isMobile || userDtoParse.accountTier === 1) {
                                                                                                  history.push('/flipbookEditor');
                                                                                              } else {
                                                                                                  history.push('/flyersCatalog');
                                                                                              }
                                               */
                                           }
                                       }}
                                       onRegisterEmailFailed={() => {
                                       }}
                                   />
                               }}/>
                        <Route exact path="/auth/flyersCatalog/completeUserRegistration/:userId/:userEmail/:token"
                               component={() => {
                                   return <CompleteUserRegistration
                                       userId={Number(userId)}
                                       userEmail={userEmail!}
                                       userToken={token!}
                                       onRegisterEmailSucceeded={() => {
                                           history.push(`/auth/flyersCatalog/setPassword/${userId}/${userEmail}/${token}`);
                                       }}
                                       onRegisterEmailFailed={() => {
                                       }}
                                   />
                               }}/>
                        <Redirect from="*" to={redirectPath}/>
                    </Switch>
                </Box>

                <Box>
                    <AuthPrivacy/>
                </Box>
            </Box>
            <Box>

            </Box>
        </Box>
    )
}

export default AuthScreen;


